import * as dayjs from 'dayjs';
import { ListenerInterface } from '@splixer/common';
import { Uuid } from '@hidat/huijs-common';
import { Expose, Transform } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

export class PlayerListener implements ListenerInterface {
  @Expose({ name: 'id' })
  id: Uuid | undefined ;

  @Expose({ name: 'name' })
  name: string | undefined ;

  @Expose({ name: 'email_address' })
  email: string | undefined ;

  @Expose({ name: 'external_id' })
  externalId: string | undefined ;

  @Expose({ name: 'avatar_url' })
  imageUrl: string | undefined ;

  @Expose({ name: 'status' })
  status = 100;

  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined ;

  @Expose({ name: 'updated_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  updatedAt: dayjs.Dayjs | undefined ;

  @Expose({name: 'updated_count'})
  updatedCount: number | undefined;
}
